import { render, staticRenderFns } from "./PreGamePlayer.vue?vue&type=template&id=080d53e4&"
import script from "./PreGamePlayer.vue?vue&type=script&lang=js&"
export * from "./PreGamePlayer.vue?vue&type=script&lang=js&"
import style0 from "./PreGamePlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080d53e4')) {
      api.createRecord('080d53e4', component.options)
    } else {
      api.reload('080d53e4', component.options)
    }
    module.hot.accept("./PreGamePlayer.vue?vue&type=template&id=080d53e4&", function () {
      api.rerender('080d53e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Player/PreGamePlayer.vue"
export default component.exports